export const getType = ({
  isBid,
  isBooking
}) => {
  if(isBid){
    return Type.BID
  }else if(isBooking){
    return Type.BOOKING
  }
  return Type.NORMAL
}

export const Type = {
  BID:'bid',
  BOOKING: 'booking',
  NORMAL: 'normal'
}


// WEBPACK FOOTER //
// ./src/misc/loadTypes.js